module.exports = [
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Mengventiel voor GROHE RED",
		"textblock_1st_text": "40841001",
		"textblock_2nd_text": "Mengventiel voor GROHE Red",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi douchesysteem met thermostaat, voor opbouw/inbouw",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-uitloop Starterkit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge L-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-uitloop Starterkit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-uitloop Starterkit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-uitloop Starterkit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge L-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starterkit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterkit: fonteinkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starterkit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterkit: fonteinkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-uitloop Starterkit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge U-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-uitloop Starterkit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge U-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi douchesysteem met thermostaat, voor opbouw/inbouw",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en M-size boiler",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (L-uitloop) met filter en M size boiler voor onmiddellijk kokend water. Supersteel afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) en een 115mm handdouche met vier straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en L-size boiler",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (C-uitloop) met filter en L size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en L-size boiler",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (L-uitloop) met filter en L size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Kraan en M-size boiler",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "GROHE Red Mono keukenkraan (C-uitloop) met filter en M size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en M-size boiler",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (C-uitloop) met filter en M size boiler voor onmiddellijk kokend water. Supersteel afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en M-size boiler",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (C-uitloop) met filter en M size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Kraan en L-size boiler<br type=\"_moz\"  />",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "GROHE Red Mono keukenkraan (C-uitloop) met filter en L size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en L-size boiler",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (C-uitloop) met filter en L size boiler voor onmiddellijk kokend water. Supersteel afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en M-size boiler",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (L-uitloop) met filter en M size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en L-size boiler",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (L-uitloop) met filter en L size boiler voor onmiddellijk kokend water. Supersteel afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Handdouche, 1 straal",
		"textblock_1st_text": "27699000",
		"textblock_2nd_text": "Euphoria Cube Stick, handdouche, 1 straal",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland, 360mm hoofddouche met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche en een 115mm handdouche met vier straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27492000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27492000/640/27492000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Hoofddouche",
		"textblock_1st_text": "27492000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180 mm hoofddouche, 9,5 l/min.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27492000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Douche-arm 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandaansluitbocht 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland, 360mm hoofddouche witte  sproeiplaat met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_nl_be.json
// module id = 884
// module chunks = 0